import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderby' })
export class OrderByPipe implements PipeTransform {
    transform(array: Array<any>, field: string): Array<any> {
        if (array && field) {
            array.sort((a: any, b: any) => {
                if (a[field] < b[field]) {
                    return -1;
                } else if (a[field] === b[field]) {
                    return 0;
                } else {
                    return 1;
                }
            });
        }

        return array;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/widgets/orderby.pipe.ts